﻿import {Core} from "./Core";
import {lazyGet} from "@dp-instant/core";
import {isHapticAvailable} from "../../dpCommonPortHelper";

export class Vibrator {
    async Vibrate(forced = false) {
        if (!Core.LocalSettings.Vibro) {
            if (!forced) return false;
        }

        let done = false;

        try {
            // if (FBInstant && FBInstant.performHapticFeedbackAsync) {
            //     await FBInstant.performHapticFeedbackAsync();
            //     done = true;
            // }

            if (isHapticAvailable()) {
                const vibrationManager = lazyGet(TypesSocial.vibrationManager);
                if (vibrationManager) {
                    vibrationManager.vibrate();
                    done = true;
                }
            }
        } catch (e) {
            // Ignore it
        }

        try {
            if (!done && window["navigator"] && window.navigator["vibrate"]) {
                window.navigator.vibrate(100);
                done = true;
            }
        } catch (e) {
            // Ignore it
        }

        return done;
    }
}
